import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import '../html/fontawesome/css/all.min.css'
import { MagstimColor } from "./../Magstim.Color";
import { CurrentTheme } from "common/utils/ThemeUtils";

//import Navbar from 'react-bootstrap/Navbar';
import { magstim_eventHandler } from "./magstim"


class MagstimNavBarBrand extends React.Component {

    handleClick(value) {
        magstim_eventHandler("click", value);
    }

    render() {
        // console.log('MagstimNavBarBrand.render props = ' + JSON.stringify(this.props));

        var icon = undefined;
        if ((undefined !== this.props.main_icon) && (null !== this.props.main_icon) && (null !== this.props.main_icon)) {
            icon = <i className={this.props.main_icon + ' pull-left d-none d-md-inline'}></i>;
        }
        
        return (
            <Wrapper>
                {icon}
                <h2 className="d-none d-md-inline">{this.props.main_title}</h2>
                <h3 className="d-md-none d-lg-none">{this.props.main_title}</h3>
            </Wrapper>
        );
    }
}

MagstimNavBarBrand.propTypes = {
    main_title: PropTypes.string,
    main_icon: PropTypes.string
};

MagstimNavBarBrand.defaultProps = {
    main_title: '',
    main_icon: undefined
};

const Wrapper = styled.div`
    color: ${ MagstimColor.MagstimGroupHeaderText };
    background-color: ${ MagstimColor.MagstimCardHeaderBackground };
    border-color: ${ MagstimColor.MagstimCardHeaderBackground };
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    i {
        margin-left: 4px;
        margin-right: 15px;
        font-size: ${ CurrentTheme().MagstimNavBarIconSize};
        color: ${ MagstimColor.MagstimGroupHeaderText };
        line-height: 40px;
        vertical-align: middle;
        background-color: ${ MagstimColor.MagstimCardHeaderBackground };
        border: none;
    }

    h2 {
        white-space: nowrap;
        display: inline-block;
        margin-left: 0px;
        margin-right: 15px;
        line-height: 40px;
        font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important;
        font-size: ${ CurrentTheme().MagstimNavBarFontSize};
        font-weight: bold;
        color: ${ MagstimColor.MagstimGroupHeaderText };
    }

    h3 {
        display: inline-block;
        margin-left: 0px;
        margin-right: 15px;
        font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important;
        font-size: ${ CurrentTheme().MagstimNavBarFontSizeSmall };
        font-weight: bold;
        color: ${ MagstimColor.MagstimGroupHeaderText };
    }

`;

export default MagstimNavBarBrand;